/**
 * `clawnify api <path>` — a raw authenticated request to the Clawnify API.
 * The escape hatch (à la `gh api` / `stripe get`): the porcelain covers the
 * common paths; this reaches anything without a dedicated command, so the CLI
 * never has to be complete to be useful. Same auth + org scoping as every other
 * command — it can only do what you can do.
 *
 *   clawnify api /servers
 *   clawnify api /servers/<id>/agents
 *   clawnify api /servers/<id>/deploy-agent -X POST -d '{"agent":"main","files":[...]}'
 */

import { api } from "../lib/api.js";

export async function apiCommand(
  path: string,
  opts: { method?: string; data?: string; org?: string },
): Promise<void> {
  const method = (opts.method || (opts.data !== undefined ? "POST" : "GET")).toUpperCase();

  let body: unknown;
  if (opts.data !== undefined) {
    try {
      body = JSON.parse(opts.data);
    } catch {
      console.error("-d/--data must be valid JSON.");
      process.exit(1);
    }
  }

  const p = path.startsWith("/") ? path : `/${path}`;
  const res = await api.call(method, p, { body, orgId: opts.org });

  const text = await res.text();
  let out = text;
  try {
    out = JSON.stringify(JSON.parse(text), null, 2);
  } catch {
    /* not JSON — pass through verbatim */
  }

  if (!res.ok) {
    console.error(`HTTP ${res.status}`);
    if (out) console.error(out);
    process.exit(1);
  }
  if (out) console.log(out);
}
